module.exports = __webpack_public_path__ + "img/new_shangpinzhutu.d2ea38ef.png";